<template>
  <header class="header" :class="{ 'header-scrolled': isScrolled }">
    <div class="header-top">
      <div class="container">
        <div class="header-top-content">
          <!-- 联系方式已暂时注释
          <div class="contact-info">
            <span><i class="icon-phone"></i> {{ t.nav.serviceHotline }}: 400-888-8888</span>
            <span><i class="icon-email"></i> sales@sunsure-cn.com</span>
          </div>
          -->
          <div class="language-switch">
            <button 
              :class="{ active: locale === 'zh' }" 
              @click="switchLanguage('zh')"
            >{{ t.language.zh }}</button>
            <span>|</span>
            <button 
              :class="{ active: locale === 'en' }" 
              @click="switchLanguage('en')"
            >{{ t.language.en }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="header-main">
      <div class="container">
        <div class="header-content">
          <div class="logo">
            <a href="#" @click.prevent="goHome">
              <img src="/vast-logo.jpg?v=2" alt="VASTI" class="logo-img">
            </a>
          </div>
          <nav class="main-nav" :class="{ 'nav-open': isMenuOpen }">
            <ul>
              <li><a href="#" :class="{ active: true }" @click.prevent="goHome">{{ t.nav.home }}</a></li>
              <li><a href="#products" @click.prevent="goHomeAndScroll('products')">{{ t.nav.products }}</a></li>
            </ul>
          </nav>
          <button class="mobile-menu-toggle" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { messages } from '../i18n/index.js'

export default {
  name: 'HeaderNav',
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      isScrolled: false,
      isMenuOpen: false
    }
  },
  computed: {
    t() {
      return messages[this.locale] || messages.en
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    goHome() {
      this.$emit('go-home')
      this.closeMenu()
    },
    goHomeAndScroll(sectionId) {
      this.$emit('go-home', sectionId)
      this.closeMenu()
    },
    switchLanguage(lang) {
      this.$emit('change-locale', lang)
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--color-surface);
  transition: all var(--transition-base);
}

.header-scrolled {
  box-shadow: var(--shadow-md);
}

.header-top {
  background: var(--color-text-heading);
  color: var(--color-surface);
  padding: var(--space-xs) 0;
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-wide);
}

.header-top-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact-info span {
  margin-right: var(--space-lg);
  opacity: 0.88;
}

.contact-info i {
  margin-right: var(--space-xs);
  color: var(--color-primary);
}

.language-switch {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.language-switch button {
  background: none;
  border: none;
  color: var(--color-surface);
  opacity: 0.7;
  cursor: pointer;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  padding: var(--space-xs) var(--space-sm);
  transition: all var(--transition-base);
  border-radius: var(--radius-sm);
}

.language-switch button.active,
.language-switch button:hover {
  opacity: 1;
  color: var(--color-primary);
  background: rgba(196, 18, 48, 0.12);
}

.language-switch span {
  opacity: 0.4;
}

.header-main {
  padding: var(--space-md) 0;
  transition: all var(--transition-base);
}

.header-scrolled .header-main {
  padding: var(--space-sm) 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo a {
  text-decoration: none;
  display: flex;
  flex-direction: column;
}

.logo-img {
  height: 60px;
  width: auto;
  object-fit: contain;
}

.logo-text {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-heading);
  letter-spacing: var(--letter-spacing-wide);
  line-height: var(--line-height-tight);
}

.logo-sub {
  font-size: var(--font-size-xs);
  color: var(--color-primary);
  letter-spacing: var(--letter-spacing-wider);
  font-weight: var(--font-weight-semibold);
}

.main-nav ul {
  display: flex;
  list-style: none;
  gap: var(--space-xl);
}

.main-nav a {
  text-decoration: none;
  color: var(--color-text);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  position: relative;
  padding: var(--space-xs) 0;
  transition: color var(--transition-base);
  letter-spacing: var(--letter-spacing-wide);
}

.main-nav a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-light));
  transition: width var(--transition-base);
  border-radius: var(--radius-full);
}

.main-nav a:hover,
.main-nav a.active {
  color: var(--color-primary);
}

.main-nav a:hover::after,
.main-nav a.active::after {
  width: 100%;
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--space-xs);
}

.mobile-menu-toggle span {
  display: block;
  width: 25px;
  height: 2px;
  background: var(--color-text-heading);
  margin: 3px 0;
  transition: all var(--transition-base);
  border-radius: var(--radius-full);
}

.mobile-menu-toggle:hover span {
  background: var(--color-primary);
}

@media (max-width: 768px) {
  .header-top {
    display: none;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .main-nav {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: var(--color-surface);
    padding: var(--space-md);
    box-shadow: var(--shadow-lg);
    transform: translateY(-150%);
    transition: transform var(--transition-base);
    border-top: 1px solid var(--color-border);
  }

  .main-nav.nav-open {
    transform: translateY(0);
  }

  .main-nav ul {
    flex-direction: column;
    gap: var(--space-xs);
  }

  .main-nav a {
    display: block;
    padding: var(--space-sm) 0;
  }
}
</style>
